import { createStyles, makeStyles, Theme } from '@material-ui/core';

const ITEM_HEIGHT = 32;
const ITEM_PADDING_TOP = 8;

export const useCustomSelectStyle = makeStyles(
  (theme: Theme) =>
    createStyles({
      input: {
        cursor: 'pointer',
      },
      root: {
        color: 'black',
      },
      '@keyframes inputLoading': {
        '0%': {
          transform: 'scaleX(0)',
          transformOrigin: 'left center',
        },
        '50%': {
          transform: 'scaleX(1)',
          transformOrigin: 'left center',
        },
        '51%': {
          transform: 'scaleX(1)',
          transformOrigin: 'right center',
        },
        '100%': {
          transform: 'scaleX(0)',
          transformOrigin: 'right center',
        },
      },
      loading: {
        overflow: 'hidden',
        '&::after': {
          animation: '$inputLoading 2s ease infinite',
        },
      },
      adornment: {
        flexFlow: 'nowrap',
      },
      adornmentButton: {
        padding: 0,
        fontSize: 23,
        color: '#828a82',
        '&:first-of-type:not(:last-of-type)': {
          fontSize: 12,
          marginRight: 4,
        },
      },
      adornmentIcon: {
        transition: 'transform 200ms ease',
        transform: 'rotate(0)',
        color: '#828a82',
        width: '12px',
        height: '12px',
        marginLleft: '-16px',
        pointerEvents: 'none',
      },
      adornmentIconRotate: {
        transform: 'rotate(180deg)',
      },
      menu: {
        maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
        backgroundColor: '#fefefe',
        boxShadow:
          '0px 0px 0px 0px rgba(0,0,0,0.0), 0px 0px 0px 1px rgba(0,0,0,0.1), 0px 0px 0px 1px rgba(0,0,0,0) !important',
        '&::-webkit-scrollbar': {
          width: 12,
          height: 12,
        },
        '&::-webkit-scrollbar-button': {
          display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
          transition: 'all .3s ease',
          borderRadius: 10,
          backgroundColor: '#cdd3cd',
          border: '3px solid #f8f9f7',
        },
      },
      menuItem: {
        minHeight: ITEM_HEIGHT,
        whiteSpace: 'normal',
      },
      menuItemCheckbox: {
        minWidth: 'unset',
        marginRight: theme.spacing(1),
      },
      menuItemFilter: {
        position: 'sticky',
        top: 0,
        left: 0,
        backgroundColor: '#fefefe',
        zIndex: 2,
      },
      menuItemActions: {
        position: 'sticky',
        bottom: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        backgroundColor: '#fefefe',
        zIndex: 2,
      },
    }),
  { name: 'CustomSelect' }
);
